// extracted by mini-css-extract-plugin
export default {"modalOverlay":"wC-z","modalContent":"xC-z","header":"yC-z","close":"zC-z"};